<template>
    <div v-if="paymentReference">
        <LoaderView v-if="loading && uiStatus === null" />
        <div v-else
         class="main">
            <img :src="payment"
             :alt="$t('dashboard.pages.paymentResult.altIllustration')">
            <h3 class="status-title">
                <template v-if="uiStatus === 'processing'">
                    {{ $t('dashboard.pages.paymentResult.processing') }}<span class="ellipsis">{{ ellipsisDots }}</span>
                </template>
                <template v-else-if="uiStatus === 'not_found'">
                    {{ $t('dashboard.pages.paymentResult.notFound') }}
                </template>
                <template v-else-if="uiStatus === 'completed'">
                    {{ $t('dashboard.pages.paymentResult.completed') }}
                </template>
                <template v-else-if="uiStatus === 'failed'">
                    {{ $t('dashboard.pages.paymentResult.failed') }}
                </template>
                <template v-else>
                    {{ $t('dashboard.pages.paymentResult.loadError') }}
                </template>
            </h3>
            <p v-if="uiStatus === 'completed'">
                {{ $t('dashboard.pages.paymentResult.thankYou') }}
            </p>
            <p>{{ $t('dashboard.pages.paymentResult.contactPrompt') }}</p>
            <p>info@35fit.com</p>
            <p>+372 5843 5415</p>
            <p>+372 5819 3357</p>
            <router-link to="/dashboard">
                <MainButton class="marg-top"
                 :text="$t('dashboard.pages.paymentResult.goToDashboard')"
                 :widthRestrict="true" />
            </router-link>
        </div>
    </div>
</template>
<script>
import payment from '@/assets/svg/payment.svg'
import MainButton from '@/components/buttons/MainButton.vue';
import LoaderView from '@/components/buttons/LoaderView.vue';

const PAYMENT_STATUS_URL = 'https://app.35fit.com/api/users/payment_status';

export default {
    name: "PaymentResultView",
    data() {
        return {
            payment,
            paymentReference: null,
            loading: true,
            uiStatus: null,
            ellipsisPhase: 0,
            pollTimerId: null,
            ellipsisTimerId: null,
        };
    },
    computed: {
        ellipsisDots() {
            const phases = ['.', '..', '...'];
            return phases[this.ellipsisPhase % 3];
        },
    },
    components: { MainButton, LoaderView },
    created() {
        const q = this.$route.query.payment_reference;
        const ref = Array.isArray(q) ? q[0] : q;
        if (!ref || String(ref).trim() === '') {
            this.$router.push('/dashboard');
            return;
        }
        this.paymentReference = String(ref).trim();
    },
    mounted() {
        if (this.paymentReference) {
            this.fetchPaymentStatus({ silent: false });
        }
    },
    beforeUnmount() {
        this.clearProcessingTimers();
    },
    methods: {
        clearProcessingTimers() {
            if (this.pollTimerId != null) {
                clearInterval(this.pollTimerId);
                this.pollTimerId = null;
            }
            if (this.ellipsisTimerId != null) {
                clearInterval(this.ellipsisTimerId);
                this.ellipsisTimerId = null;
            }
        },
        startProcessingAnimations() {
            if (this.ellipsisTimerId == null) {
                this.ellipsisTimerId = setInterval(() => {
                    this.ellipsisPhase = (this.ellipsisPhase + 1) % 3;
                }, 500);
            }
            if (this.pollTimerId == null) {
                this.pollTimerId = setInterval(() => {
                    this.fetchPaymentStatus({ silent: true });
                }, 5000);
            }
        },
        applyStatusPayload(data) {
            if (data.success === false) {
                this.clearProcessingTimers();
                this.uiStatus = 'not_found';
                return;
            }
            if (data.success === true) {
                if (data.status === 'completed' || data.status === 'failed') {
                    this.clearProcessingTimers();
                    this.uiStatus = data.status;
                    return;
                }
                if (data.status === 'processing') {
                    this.uiStatus = 'processing';
                    this.startProcessingAnimations();
                    return;
                }
            }
            this.clearProcessingTimers();
            this.uiStatus = 'error';
        },
        async fetchPaymentStatus({ silent } = {}) {
            if (!silent) {
                this.loading = true;
            }
            const headers = {
                'Content-Type': 'application/json',
            };
            const token = localStorage.getItem('token');
            if (token) {
                headers['Authorization'] = 'Bearer ' + token;
            }
            const url = `${PAYMENT_STATUS_URL}?payment_reference=${encodeURIComponent(this.paymentReference)}`;
            try {
                const res = await fetch(url, { method: 'GET', headers });
                let data;
                try {
                    data = await res.json();
                } catch {
                    this.clearProcessingTimers();
                    this.uiStatus = 'error';
                    return;
                }
                this.applyStatusPayload(data);
            } catch {
                this.clearProcessingTimers();
                this.uiStatus = 'error';
            } finally {
                if (!silent) {
                    this.loading = false;
                }
            }
        },
    },
}
</script>
<style scoped>
.main {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 20px;
    height: 100vh;
    min-height: 500px;
    padding: 20px;
}

.status-title {
    text-align: center;
}

.ellipsis {
    display: inline-block;
    min-width: 1.25em;
    text-align: left;
}

a {
    width: 100%;
}

p {
    max-width: 450px;
    font-size: 14px;
    font-weight: 500;
    text-align: center;
}

img {
    width: 100%;
    max-width: 350px;
}

@media screen and (max-width: 420px) {

    img {
        max-width: 300px;
    }

}
</style>
